import type { JSX } from "react";
import type { ChildrenProp } from "@charterindex/armoury-www";
import { NullContextError } from "@charterindex/armoury-www";
import { observable } from "ecce-react";
import { createContext, useContext } from "react";
import { Controller, useController } from "../../../util/controller";


export class NavSubMenuController extends Controller {
	#openMenuLabelKey: string | null = null;
	get openMenuLabelKey(): string | null { return this.#openMenuLabelKey; }
	@observable() private set openMenuLabelKey(value: string | null) { this.#openMenuLabelKey = value; }

	toggleMenuOpen(nextMenuLabelKey: string | null): void {
		this.openMenuLabelKey = nextMenuLabelKey === this.openMenuLabelKey
			? null
			: nextMenuLabelKey;
	}

	override dispose(): void {
		this.#openMenuLabelKey = null;
	}
}

const navSubMenuControllerContext = createContext<NavSubMenuController | null>(null);
export const NavSubMenuControllerProvider = ({ children }: ChildrenProp): JSX.Element => {
	const controller = useController(NavSubMenuController);

	return (
		<navSubMenuControllerContext.Provider value={ controller }>
			{ children }
		</navSubMenuControllerContext.Provider>
	);
};

export const useNavSubMenuController = (): NavSubMenuController => {
	const ctx = useContext(navSubMenuControllerContext);
	if(!ctx) {
		throw new NullContextError("navSubMenuControllerContext", "NavSubMenuControllerProvider");
	}

	return ctx;
};